/**
 * ChecklistDetailsPanel — thin shell wiring the shared `ListDetailsPanel`
 * substrate with checklist-specific bits:
 *   - checklist metadata layout
 *   - checklist row actions (close / reopen)
 *   - status badge (Open / Completed)
 *   - progress indicator (templates have no answers, so this is checklist-only)
 *   - PDF download
 */
import { ListDetailsPanel } from '@/features/lists/ListDetailsPanel';
import { checklistDetailLayout } from '@/features/lists/lists.schemas';
import type { RoutedPanelProps } from '@/components/Layout/Panel/Panel';
import { getChecklistActions } from './checklists.actions';

export function ChecklistDetailsPanel(props: RoutedPanelProps) {
  return (
    <ListDetailsPanel
      {...props}
      layout={checklistDetailLayout}
      getActions={getChecklistActions}
      showStatusBadge
      showProgress
      showPdfDownload
    />
  );
}
